var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItalyFlag(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 40,
    viewBox: "0 0 64 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#d22f27;}.cls-3{fill:#5c9e31;}.cls-4{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emoji"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 1,
    width: 62,
    height: 38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1,
    y: 1,
    width: 21,
    height: 38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42,
    y: 1,
    width: 21,
    height: 38
  })), /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1,
    y: 1,
    width: 62,
    height: 38
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalyFlag);
export default __webpack_public_path__ + "static/media/italy-flag.62b1ec4d990fef2aa7d2c3c63cbed6ca.svg";
export { ForwardRef as ReactComponent };